import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronMinimizeDiagonal2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M14 20L14 14L20 14", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M10 4L10 10L4 10", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronMinimizeDiagonal2.js.map